/**
 *
 * Share
 *
 */

import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import MixPanel from 'utils/mixpanelService';
import {
  FacebookShareButton,
  TwitterShareButton,
  EmailShareButton,
  LinkedinShareButton,
  PinterestShareButton,
  FacebookIcon,
  TwitterIcon,
  EmailIcon,
  LinkedinIcon,
  PinterestIcon,
} from 'react-share';
import { getImageFile, getParentShareUrl } from 'utils/stringUtils';

const styles = theme => ({
  icon: {
    marginLeft: 5,
    marginRight: 5,
    outline: 'none',
    cursor: 'pointer',
    filter: 'grayscale(1)',
    '&:hover': {
      filter: 'grayscale(0)',
    },
    [theme.breakpoints.down('479')]: {
      marginLeft: 10,
      marginRight: 10,
    },
  },
  iconWrapper: {
    display: 'flex',
  },
  titleWrapper: {
    marginBottom: 10,
  },
});

class Share extends React.PureComponent {
  handleClick = social => {
    const {
      data: { name = '', title = '', type: resourceSubtype, blog },
      type,
    } = this.props;

    let subtype;
    if (type === 'app') {
      if (resourceSubtype === 'Online Therapy') subtype = resourceSubtype;
      else subtype = 'Apps';
    }
    if (type === 'organization') {
      subtype = resourceSubtype;
    }
    if (type === 'article') {
      subtype = resourceSubtype;
    }

    MixPanel.track('Sharing Resource', {
      name: name || title,
      type,
      subtype,
      blog,
      social,
    });
  };

  render() {
    const { data, classes, hideLabel } = this.props;
    const parentHref = getParentShareUrl();
    const shareUrl = parentHref || window.location.href;
    const { name = '', title = '' } = data;
    const quote = `${name || title} @CredibleMind`;
    const image = getImageFile(data);
    return (
      <Grid container alignItems="center">
        {!hideLabel && (
          <Grid item xs={12} className={classes.titleWrapper}>
            <Typography variant="caption" color="textPrimary">
              Share
            </Typography>
          </Grid>
        )}
        <Grid item className={classes.iconWrapper}>
          <FacebookShareButton
            url={shareUrl}
            quote={quote}
            className={classes.icon}
            beforeOnClick={() => this.handleClick('facebook')}
          >
            <FacebookIcon size={32} round />
          </FacebookShareButton>
          <TwitterShareButton
            url={shareUrl}
            title={quote}
            className={classes.icon}
            beforeOnClick={() => this.handleClick('twitter')}
          >
            <TwitterIcon size={32} round />
          </TwitterShareButton>
          <EmailShareButton
            url={shareUrl}
            subject={quote}
            className={classes.icon}
            beforeOnClick={() => this.handleClick('email')}
          >
            <EmailIcon size={32} round />
          </EmailShareButton>
          <LinkedinShareButton
            url={shareUrl}
            title={quote}
            windowWidth={750}
            windowHeight={600}
            className={classes.icon}
            beforeOnClick={() => this.handleClick('linkedin')}
          >
            <LinkedinIcon size={32} round />
          </LinkedinShareButton>
          <PinterestShareButton
            url={String(window.location)}
            media={image}
            windowWidth={1000}
            windowHeight={730}
            className={classes.icon}
            beforeOnClick={() => this.handleClick('pinterest')}
          >
            <PinterestIcon size={32} round />
          </PinterestShareButton>
        </Grid>
      </Grid>
    );
  }
}

Share.propTypes = {
  classes: PropTypes.object,
  data: PropTypes.object,
  type: PropTypes.string,
  hideLabel: PropTypes.bool,
};

Share.defaultProps = {
  hideLabel: false,
};

export default withStyles(styles)(Share);
